import { useCompanyAddressStore } from "~/stores/companyaddressstore";
import { useCountriesStore } from "~/stores/countriesstore";

export function useLegalAddressCountryLoader() {
  const companyAddressStore = useCompanyAddressStore();
  const countriesStore = useCountriesStore();

  watch(
    () => [companyAddressStore.legalAddress?.country, countriesStore.countries],
    async () => {
      await companyAddressStore.loadCompanyLegalAddressCountry(
        companyAddressStore.legalAddress,
        countriesStore.countries,
      );
    },
    { immediate: true },
  );
}
